import styled from 'styled-components'

import Check from 'share-ui/components/Icon/Icons/components/Check'
import Copy from 'share-ui/components/Icon/Icons/components/Copy'
import { useCopyButton } from './useCopyButton'

export type CopyButtonProps = {
    onCopyClick?: () => void
    value?: string
    dark?: boolean
    label?: string
}

const CopyButton = ({ onCopyClick, value = '', dark = false }: CopyButtonProps) => {
    const { handleCopyClick, copied } = useCopyButton({ onCopyClick, value })

    return (
        <StyledActionButton onClick={handleCopyClick}>
            {copied ? (
                <StyledCheckIcon size={22} dark={dark} />
            ) : (
                <StyledCopyIcon size={22} dark={dark} />
            )}
        </StyledActionButton>
    )
}

export default CopyButton

export const StyledActionButton = styled.div`
    opacity: 0.5;
    :hover {
        opacity: 1;
        cursor: pointer;
    }

    padding-bottom: 2px;
`

export const StyledCopyIcon = styled(Copy)<{ dark: boolean }>`
    path {
        fill: ${({ dark, theme }) => (dark ? '#374151' : theme.body.iconColor)};
    }
`
export const StyledCheckIcon = styled(Check)<{ dark: boolean }>`
    path {
        fill: ${({ dark, theme }) => (dark ? '#374151' : theme.body.iconColor)};
    }
`
